
import { createApp } from "vue"
import {
  ElButton,
  ElForm,
  ElDialog,
  ElInput,
  ElDatePicker,
  ElSelect,
  ElRadio,
  ElDescriptions,
  ElRadioGroup,
  ElOption,
  ElTimeline,
  ElTimelineItem,
  ElAvatar,
  ElSelectV2,
  ElIcon,
  ElDrawer,
  ElConfigProvider,
  ElCascader,
  ElSwitch,
  ElInputNumber,
  ElImage,
  ElImageViewer,
  ElRow,
  ElCol,
  ElTable,
  ElCheckboxGroup,
  ElCheckbox,
  ElEmpty,
  ElTooltip,
  ElLoading
} from "element-plus"

import store from "../store"
import fetch from "@/service/fetch"
import message_box from "@/components/common/MessageBox.js"
import router from "../router"
import { filters } from "@/service/index"

/**
 * modalConstructor 为传入的业务组件，
 * options 为调用业务组件时可传入的参数
 */
export default function createCustomModal(modalConstructor, options) {
  return new Promise((resolve, reject) => {
    let app = null
    let instance = null

    const container = document.createElement("div")
    // 去除编译时的警告
    container.id = "dialog_" + Date.now()
    document.body.appendChild(container)

    // 销毁元素
    function destroyNodes() {
      instance = null
      app?.unmount()
      if (document.body.contains(container)) {
        document.body.removeChild(container)
      }
    }

    // 定义close方法
    function close(v) {
      reject(v)
      destroyNodes()
    }

    // 定义ok方法
    function ok(val) {
      resolve(val)
      destroyNodes()
    }
    // 使用createAPP方法生成vue实例，第一个参数modalConstructor为component类型，
    // 第二个参数为传递给modalConstructor组件的参数props
    app = createApp(modalConstructor, {
      close,
      ok,
      ...options,
    })
    
    app.provide("$tm_message_box", message_box)
    app.provide("$fetch", fetch)
    app.provide("$filters", filters)
    app.provide("$store", store)
    instance = app
      .use(router)
      .use(ElDialog)
      .use(ElButton)
      .use(ElForm)
      .use(ElInput)
      .use(ElRadio)
      .use(ElSelect)
      .use(ElDescriptions)
      .use(ElRadioGroup)
      .use(ElOption)
      .use(ElTimeline)
      .use(ElTimelineItem)
      .use(ElAvatar)
      .use(ElSelectV2)
      .use(ElIcon)
      .use(ElDrawer)
      .use(ElConfigProvider)
      .use(ElCascader)
      .use(ElSwitch)
      .use(ElInputNumber)
      .use(ElImage)
      .use(ElImageViewer)
      .use(ElRow)
      .use(ElCol)
      .use(ElTable)
      .use(ElCheckboxGroup)
      .use(ElCheckbox)
      .use(ElEmpty)
      .use(ElTooltip)
      .use(ElLoading)
      .component(ElDatePicker.name, ElDatePicker)
      .mount(container) // 渲染到创建的div节点上

    // 加延迟是避免el-table中的el-button在关闭弹框后，不失去焦点 JTMLF-659
    setTimeout(() => {
      instance.dialogVisible = true
    }, 0)

    if (options.config?.zIndex) {
      modalConstructor
    }
  })
}
